

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './ContentFeed.css';
import api from '../utils/api';

const ContentFeed = () => {
	const [items, setItems] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const navigate = useNavigate();
	const location = useLocation();

	// section/category query
	const search = new URLSearchParams(location.search);
	const section = search.get('contentType') || 'info';
	const category = search.get('category') || '';

	useEffect(() => {
		const load = async () => {
			setLoading(true);
			setError(null);
			try {
				const params = {};
				if (section) params.section = section;
				if (category) params.category = category;
				const res = await api.get('/content', { params });
				setItems(res.data.items || []);
			} catch (err) {
				setError('Нийтлэлүүд уншихад алдаа гарлаа');
			} finally {
				setLoading(false);
			}
		};
		load();
	}, [section, category]);

	if (loading) return <div className="content-feed"><div>Уншиж байна...</div></div>;
	if (error) return <div className="content-feed"><div>{error}</div></div>;

	return (
		<div className="content-feed">
			<div className="article-feed article-feed-wide">
				{items.length === 0 && <div>Нийтлэл олдсонгүй</div>}
				{items.map((item) => (
					<div
						key={item._id}
						className="article-post article-post-wide"
						style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 auto', maxWidth: 700 }}
						onClick={() => navigate(`/content/${item._id}`)}
					>
						{item.imageUrl && (
							<img
								src={item.imageUrl}
								alt={item.title}
								style={{ maxWidth: '100%', maxHeight: 340, objectFit: 'cover', borderRadius: 10, marginBottom: 16 }}
							/>
						)}
						<h2 style={{ textAlign: 'center', fontSize: '1.6rem', fontWeight: 700, margin: '0 0 8px 0' }}>{item.title}</h2>
					</div>
				))}
			</div>
		</div>
	);
};

export default ContentFeed;


